import React, { Component } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import autoBind from 'react-autobind';
//
import CustomComponent from "./../../components/CustomComponent";
import LogForm from "./AdvisorLogForm";
import CommonLoadingView from "./CommonLoadingView";
//
export default class CommonLogTable extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this,"handleBackButton","fetchData");
    this.state = { error: false, data: [], firstLoad: true };
  }
  loadResponse(response) {
    if (response['data'] != null) { //valid data state
      this.state.data = response['data'][0];
      this.state.firstLoad =  false;
    }else { //non-valid data state
      if (response["errorData"]) this.props.alertController.showErrorAlert("Error!","",response);
      this.state.data = [];
      this.state.firstLoad =  false;
    }
    this.logForm.loadData(this.state.data);
    this.setState(this.state);
  }
  async componentDidMount() {
    if (this.state.firstLoad) this.fetchData();
  }
  //Acitons
  handleBackButton() {
    this.props.navigationController.popView();
  }
  //API
  fetchData() {
    this.startLoading();
    this.props.app.sharedAPIWrapper().fetchLogEntry(this.props.reportLGID,response => {
      if (!this._isMounted) return;
      this.stopLoading();
      this.loadResponse(response);
    });
  }
  //Util
  startLoading() {
    this.state.isLoading = true;
    this.setState(this.state);
  }
  stopLoading() {
    this.state.isLoading = false;
    this.setState(this.state);
  }
  //UI
  render() {
    return (<div className="AppPageContainer">
              <CommonLoadingView isLoading={this.state.isLoading}/>
              <LogForm actionType="VIEW" app={this.props.app} data={this.state.data}
                       ref={c => (this.logForm = c)}
                       navigationController={this.props.navigationController}
                       alertController={this.props.alertController}/>
           </div>);
  }
}
